import API from "./API";

export const login = async (data) => {
  return API.post(`ams/login`, data)
    .then((response) => response.data)
    .catch((error) => error.response);
};

export const verifyOTP = async (data) => {
  return API.post(`ams/verify-otp`, data)
    .then((response) => response.data)
    .catch((error) => error.response);
};

export const resendPin = async (data) => {
  return API.post(`ams/resend-password`, data)
    .then((response) => response.data)
    .catch((error) => error.response);
};

export const getUserInfoDetails = async () => {
  return API.get(`ams/user-info`)
    .then((response) => response.data)
    .catch((error) => error.response);
};
